/**
 * Tab invitation loaded inside its own iframe
 */
import chatTabTemplate from '../templates/invitations/chatTab/chattab.ejs';
import addStyleTextInIframe from '../core/hooks/addStyleTextInIframe';
import ChatMode from '../core/hooks/ChatMode';
import getStyle from '../core/hooks/getStyle';
import { BaseWidget } from '../core/BaseWidget';
import { ChatType } from '../core/enums/Enum';
import WidgetTypes from '../core/enums/WidgetTypes';
import TabPositioner from '../core/positioners/TabPositioner';
import WidgetView from '../core/WidgetView';
import setChatTabStyles from '../core/hooks/setChatTabStyles';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import observe from '../core/hooks/observe';
import WidgetStates from '../core/hooks/WidgetStates';
import showElement from '../core/hooks/showElement';
import hideElement from '../core/hooks/hideElement';
import replaceClass from '../core/hooks/replaceClass';
import addClass from '../core/hooks/addClass';
import logIt from '../../logIt';

export default class TabInvitation extends BaseWidget {
    constructor(options) {
        if (!options.chatTab) {
            console.log('tab not enabled');
            return;
        }
        // options.containerId = 'apexchat_static_tab_text';
        super(Object.assign(options, { widget: WidgetTypes.Tab, styleName: 'tab' }));
        this.positioner = new TabPositioner(this.options, this.DOM);
        this.ready();
    }

    ready() {
        super.ready();
        this.create();
    }

    create() {
        super.create();
        const me = this;
        const polyfills = [];
        const handleMaximizedFont = function () {
            const re = new RegExp('"', 'g');
            this.model.fontFamily = this.model.fontFamily.replace(re, "'");
        };
        me.options.chatTab.style = `top: 0; background-color:${me.options.chatTab.backgroundColor} `;
        const handleWidgetFont = function () { };
        polyfills.push(handleMaximizedFont);
        this.view = new WidgetView({
            dom: this.DOM,
            identifier: WidgetTypes.Tab,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    tpl: chatTabTemplate(me.options.chatTab),
                    model: me.options.chatTab,
                    polyfills,
                    afterRender(tpl) {
                        // JIRA_2872 - START - Seperated ChatTab/ChatBar CSS Files (previously css content was written inside .htm file)
                        // const bindingDynamicStyles = parseTemplate(
                        //     me.options.chatTab.chatTabCSS,
                        //     me.options.chatTab
                        // );
                        setChatTabStyles(me.DOM, me.options.chatTab);
                        // addStyleTextInIframe(
                        //     bindingDynamicStyles,
                        //     'apexchat_chat_tab_css',
                        //     undefined,
                        //     me.DOM
                        // );
                        addStyleTextInIframe(
                            me.options.invitationWidgetStyle,
                            'apexchat_custom_fontAwesome',
                            undefined,
                            me.DOM
                        );
                        // JIRA_2872 - END
                        // JIRA_3160 - START
                        if (
                            me.options.chatTab.chatTabAnimate == 'ColorChange' &&
                            me.options.chatTab.chatTabTimer != 0
                        ) {
                            let shown = true;
                            function chatTabColorChange() {
                                if (shown) {
                                    ApexChat.animate(
                                        me.DOM.getElementById('apexchat_static_tab_text'),
                                        `background-color: ${me.options.chatTab.backgroundAnimateColor}`,
                                        {
                                            duration: 1000
                                        }
                                    );
                                    shown = false;
                                } else {
                                    ApexChat.animate(
                                        me.DOM.getElementById('apexchat_static_tab_text'),
                                        `background-color: ${me.options.chatTab.backgroundColor}`,
                                        {
                                            duration: 1000
                                        }
                                    );
                                    shown = true;
                                }
                            }
                            setInterval(chatTabColorChange, me.options.chatTab.chatTabTimer * 1000);
                        }
                        // JIRA_3160 - END
                        const target = me.DOM.getElementById('apexchat_static_tab_text');
                        me.positioner.position({
                            element: target,
                            widgetType: WidgetTypes.Tab
                        });
                        if (me.options.chatTab.chatTabType == ChatType.standard) {
                            if (me.options.chatMode == ChatMode.Windowed) {
                                me.bindWindowedHandler('#apexchat_static_tab', WidgetTypes.Tab);
                            } else {
                                me.setClickCallToAction('apexchat_static_tab', 'Tab'); // starting standard chat DOM/Windowed
                            }
                        } else {
                            me.setClickCallToAction('apexchat_static_tab', 'TabSMS');
                        }

                        me.DOM.getElementById('apexchat_tab_spaces').style.fontSize = '12px';
                        me.DOM.getElementById('apexchat_static_tab').style.whiteSpace = 'nowrap';
                        const mainDiv = this.DOM.getElementById(
                            WidgetTypes.Tab + WidgetStates.ShownMaximized
                        );

                        const height = getStyle(target, 'height');
                        const border = getStyle(target, 'border-width');
                        const wrapperMarginLeft = parseFloat(
                            document.getElementById(me.options.parentDivId).style.marginLeft
                        );
                        const borderWidth = parseFloat(border);
                        const borderWidthTwice = 2 * borderWidth;
                        const heightWithBorder = `${parseFloat(height) + borderWidthTwice}px`; // add lef and right border width to the height to get actual height

                        let width = 0; // we will use this in maxmized state
                        mainDiv.style.position = target.style.position;
                        mainDiv.style.height = height;
                        target.style.top = '0px';
                        // JIRA_2964 - START - Tab collapsible -
                        let isTabMinimized = false; // used this flag because we need to control some stuff and state of Tab
                        if (me.options.chatTab.chatTabCollapsibleEnabled) {
                            // Major FLAG coming from Portal deciding that which Tab should be shown
                            // Show newly modified TAB
                            const chatTabPosition = me.options.chatTab.chatTabLeftSide
                                ? 'left'
                                : 'right'; // We need in string that Tab is left or Right
                            // Assigning Chevron icon accordingly if Position is Left the arrow should point towards right and vice-versa
                            if (chatTabPosition == 'left') {
                                addClass(
                                    this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                    'apexchat-icon-angle-double-left'
                                );
                            } else {
                                addClass(
                                    this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                    'apexchat-icon-angle-double-right'
                                );
                            }

                            this.bind('#apexchat_tab_toggle_tab_bar', 'click', function (args) {
                                // cache apexchat_static_tab_text width on load
                                if (width == 0) {
                                    width = getStyle(target, 'width');
                                    width = `${parseFloat(width) + 40 + borderWidth}px`;
                                }
                                mainDiv.style.display = 'none';
                                setTimeout(() => {
                                    mainDiv.style.display = 'block';
                                }, 100);
                                if (isTabMinimized) {
                                    // maximize or expande it?
                                    isTabMinimized = false;
                                    // showing TEXT and increasing size of the TAB_BAR
                                    me.animator.tabMaximize({ element: me.options.parentDivId });
                                    showElement(
                                        me.DOM.getElementById('apexchat_static_tab'),
                                        true
                                    );
                                    // resize wrappers
                                    target.style.width = `${parseFloat(width) - (40 + borderWidth)
                                        }px`;
                                    target.style.marginTop = '0px';
                                    document.getElementById(me.options.iframeId).style.height =
                                        heightWithBorder;
                                    document.getElementById(me.options.iframeId).style.width =
                                        width;
                                    document.getElementById(me.options.parentDivId).style.height =
                                        heightWithBorder;
                                    document.getElementById(me.options.parentDivId).style.width =
                                        width;
                                    // Changing the Chevron (Arrow) direction according to position
                                    if (chatTabPosition === 'left') {
                                        replaceClass(
                                            this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                            'apexchat-icon-angle-double-right',
                                            'apexchat-icon-angle-double-left'
                                        );
                                    } else {
                                        replaceClass(
                                            this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                            'apexchat-icon-angle-double-left',
                                            'apexchat-icon-angle-double-right'
                                        );
                                    }
                                    // Reducing Visitor's step - START: To start chat (CHAT-2964 - Ali's requirements)
                                    // summary: In Collapsible TAB, First visitor will see the maximized state of the tab and he will minimize it by clicking on chevron, but if visitor clicks on chevron again to maximize the TAB, TAB will be maximized and CHAT will be started simultanously.
                                    me.DOM.getElementById('apexchat_static_tab').click(); // Reducing Visitor's step - END
                                } else {
                                    // minimize or collapse it?
                                    isTabMinimized = true;
                                    // hidding TEXT just showing icon and decreasing size of the TAB_BAR
                                    me.animator.tabMinimize({ element: me.options.parentDivId });
                                    hideElement(
                                        me.DOM.getElementById('apexchat_static_tab')
                                    );
                                    // resize wrappers
                                    const minWidth = `${borderWidth + 95}px`;
                                    target.style.width = '57px';
                                    target.style.marginTop = '0px';
                                    // document.getElementById(me.options.parentDivId).style.marginLeft = wrapperMarginLeft + borderWidth + 'px';
                                    document.getElementById(me.options.parentDivId).style.height =
                                        heightWithBorder;
                                    document.getElementById(me.options.parentDivId).style.width =
                                        minWidth;
                                    document.getElementById(me.options.iframeId).style.height =
                                        heightWithBorder;
                                    document.getElementById(me.options.iframeId).style.width =
                                        minWidth;
                                    // Changing the Chevron (Arrow) direction according to position
                                    if (chatTabPosition == 'left') {
                                        replaceClass(
                                            this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                            'apexchat-icon-angle-double-left',
                                            'apexchat-icon-angle-double-right'
                                        );
                                    } else {
                                        replaceClass(
                                            this.DOM.getElementById('apexchat_tab_chevron_toggle'),
                                            'apexchat-icon-angle-double-right',
                                            'apexchat-icon-angle-double-left'
                                        );
                                    }
                                }
                            });
                            // JIRA_2964 - Ali's request in comments when TAB is minimized chatbubble should be clickable in this case only to START CHAT!
                            observe(
                                me.DOM.getElementsByClassName('apexchat_tab_typing_indicator')[0],
                                'click',
                                () => {
                                    if (isTabMinimized) {
                                        // Making sure that TAB is minimized!
                                        me.DOM.getElementById('apexchat_static_tab').click();
                                    }
                                }
                            );
                            // JIRA_2964 - Ali's request - END
                        } else {
                            // Show classical TAB
                            hideElement(this.DOM.getElementById('apexchat_tab_spaces'));
                            hideElement(
                                this.DOM.getElementsByClassName('apexchat_tab_rotate')[0]
                            );
                            if (
                                me.options.chatTab.showTabBubbleIcon &&
                                this.DOM.getElementById('apexchat_chat_tab_bubble_icon')
                            ) {
                                showElement(
                                    this.DOM.getElementById('apexchat_chat_tab_bubble_icon'),
                                    true
                                ); // sending true because showElement takes element as parameter and apply display block, if your want element to be dispaly: inline-block then send 'true' as second parameter
                                const bubbleIconClass =
                                    me.options.chatTab.chatTabType == ChatType.standard
                                        ? 'apexchat_chat_tab_bubble_icon'
                                        : 'apexchat_chat_tab_bubble_icon_sms';
                                addClass(
                                    this.DOM.getElementById('apexchat_chat_tab_bubble_icon'),
                                    bubbleIconClass
                                );
                            }
                        }
                        // JIRA_2964 - END
                        target.style.marginTop = '0px';
                        me.show();
                        RunAsSoonAs(
                            () => {
                                const widgetIframe = document.getElementById(me.options.iframeId);

                                const contentWidth = me.getTextWidth(
                                    me.options.chatTab,
                                    widgetIframe.style.width
                                );
                                // const contentWidth = parseInt(getStyle(target, 'width'));
                                const contentHeight = parseInt(getStyle(target, 'height'), 10);
                                let extraPaddings = 28;
                                if (me.options.chatTab.showTabBubbleIcon) {
                                    extraPaddings = 62;
                                }
                                const extraHeight = 8;
                                logIt(`Tab width:${contentWidth}`);
                                widgetIframe.style.width = `${contentWidth + extraPaddings}px`;
                                widgetIframe.style.height = `${contentHeight + extraHeight}px`;
                            },
                            () => parseInt(getStyle(target, 'width'), 10) !== 0 // check for width availability
                        );
                    }
                }
            ],
            initialState: WidgetStates.ShownMaximized,
            polyfills: [handleWidgetFont]
        });
    }

    getTextWidth(options, elementWidth) {
        if (!this.textCanvas) {
            this.textCanvas = document.createElement('canvas');
        }

        const context = this.textCanvas.getContext('2d');
        if (!context) {
            // Return a default width for non browser rendering.
            return elementWidth || 100;
        }

        const isFontSizeSet =
            options.fontSize !== undefined &&
            options.fontSize !== 'inherit' &&
            options.fontSize !== 'normal';
        const fontSize = isFontSizeSet ? options.fontSize : '16px';
        const rawFontFamily = options.fontFamily || 'Roboto';
        const fontFamily = rawFontFamily.replace('Regular', '').trim();
        const fullFont = `${fontSize} "${fontFamily}", sans-serif`;

        context.font = fullFont;
        return context.measureText(options.text || '').width;
    }

    show() {
        super.show();
        this.maximize();
    }

    maximize() {
        super.maximize();
    }
}
